var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 61,
    height: 61,
    rx: 12.3906,
    fill: "url(#paint0_linear_14167_5285)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9871 25.8206C40.7276 25.8206 37.4832 25.8206 34.2237 25.8206C34.6958 23.2695 35.168 20.7336 35.6402 18.1826C36.219 15.0881 36.7826 12.0087 37.3614 8.91429C37.3614 8.91429 37.3614 8.91429 37.3614 8.89919C37.5746 7.73688 36.1581 7.14818 35.4574 8.09916C34.1932 9.85017 32.9442 11.6012 31.68 13.3522C29.1211 16.9146 26.5622 20.477 24.0033 24.0243C22.4496 26.1829 20.9113 28.3263 19.3576 30.4849C18.8702 31.1642 18.3676 31.8585 17.8802 32.5378C17.6212 32.9001 17.3623 33.2624 17.1034 33.6246C16.6312 34.2737 17.2709 35.1794 18.002 35.1794C21.2616 35.1794 24.5059 35.1794 27.7655 35.1794C27.2933 37.7305 26.8211 40.2664 26.3489 42.8174C25.7701 45.9119 25.2066 48.9913 24.6278 52.0857C24.6278 52.0857 24.6278 52.0857 24.6278 52.1008C24.4145 53.2631 25.8311 53.8518 26.5317 52.9008C27.7959 51.1498 29.0449 49.3988 30.3091 47.6478C32.8681 44.0854 35.427 40.523 37.9859 36.9757C39.5395 34.8171 41.0779 32.6737 42.6315 30.5151C43.1189 29.8358 43.6216 29.1415 44.109 28.4622C44.3679 28.0999 44.6268 27.7376 44.8858 27.3754C45.358 26.7112 44.7182 25.8206 43.9871 25.8206Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14167_5285",
    x1: 0.499999,
    y1: 61,
    x2: 61.5,
    y2: -5.86748e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18A0D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "#00BADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#00D1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4EE4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7F288"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app-icon.dfa2dc9e648805e49d7aaab6651855ba.svg";
export { ForwardRef as ReactComponent };